import { motion } from "framer-motion";

const easeOut = [0.22, 1, 0.36, 1];

// Fade + rise on scroll into view
export function Reveal({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: easeOut }}
    >
      {children}
    </motion.div>
  );
}

// Split a string of words with staggered masked rise, driven by a parent
// variant + staggerChildren (reliable for whileInView on inline word spans)
export function RevealWords({ text, className = "", delay = 0 }) {
  const words = text.split(" ");
  const container = {
    hidden: {},
    show: { transition: { staggerChildren: 0.08, delayChildren: delay } },
  };
  const child = {
    hidden: { y: "110%" },
    show: { y: 0, transition: { duration: 0.9, ease: easeOut } },
  };
  return (
    <motion.span
      className={className}
      variants={container}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-80px" }}
    >
      {words.map((w, i) => (
        <span
          key={i}
          style={{
            display: "inline-block",
            overflow: "hidden",
            verticalAlign: "bottom",
            paddingBottom: "0.22em",
            marginBottom: "-0.22em",
          }}
        >
          <motion.span className="inline-block" variants={child}>
            {w}
            {i < words.length - 1 ? "\u00A0" : ""}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
}
